import dynamic from 'next/dynamic';

import VideoIcon from '@/icons/duotone/video.svg';
import { FeaturedText } from '@/molecules';

import type { FunctionComponent } from 'react';
import type { TypeVideoProps } from './types';

const ModalVideo = dynamic(() => import('@/molecules/modal-video'), {
  ssr: true,
});

export const Video: FunctionComponent<TypeVideoProps> = ({
  className = '',
  src,
  flat,
}: TypeVideoProps) => (
  <FeaturedText
    Icon={VideoIcon}
    text="Explora tu nueva casa con un video"
    className={className}
  >
    <ModalVideo type="button" src={src} flat={flat} />
  </FeaturedText>
);

Video.displayName = 'Video';
